<template>
  <h1>404: Page Not Found!</h1>
  <p>I don't know who told you to come here, but maybe stop listening to them. <br>Check out the navbar above to try one of our real pages.</p>
</template>

<script>
export default {

}
</script>

<style>

</style>